import React, { useEffect, useState } from 'react';

import DonationFailure from './DonationFailure';
import DonationForm from './DonationForm';
import DonationSuccess from './DonationSuccess';

const DonationContainer = () => {
  const [status, setStatus] = useState('loading');
  const params = new URLSearchParams(process.browser && window.location.search);
  const statusParams = params.get('orderStatusId');

  useEffect(() => {
    setStatus(statusParams);
  }, [statusParams]);

  if (status > 0) return <DonationSuccess />;

  if (status < 0) return <DonationFailure />;

  if (status === 'loading') return null;

  return <DonationForm />;
};

export default DonationContainer;
